import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { APP_ROUTING } from "./app.routes";
import { AppComponent } from "./app.component";
import { SpinerComponent } from "./components/shared/spiner/spiner.component";
import { FooterComponent } from "./components/shared/footer/footer.component";
import { NavbarComponent } from "./components/shared/navbar/navbar.component";
import { HomeComponent } from "./components/home/home.component";
import { ExamplePipe } from "./pipes/example.pipe";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BlockUIModule } from "ng-block-ui";
import { MenuComponent } from "./components/menu/menu.component";
import { ToastrModule } from "ngx-toastr";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CookieModule, CookieService } from "ngx-cookie";
import { ContenedorComponent } from "./components/contenedor.component";
import { SliderComponent } from "./components/slider/slider.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { DialogService } from "./services/dialog/dialog.service";
import { ClienteService } from "./services/cliente/cliente.service";
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from "@angular/material";
import { LengthNumberDirective } from "./directives/legth-number.directive";
import { LengthDirective } from "./directives/legth.directive";
import { MensajeLabelNegocioComponent } from "./components/shared/mensaje-label-negocio/mensaje-label-negocio.component";
import { ValidarCiudadDirective } from "./directives/validar-ciudad.directive";
import { HttpCustom } from "./services/http/http-custom.service";
import { SpinnerService } from "./services/spinner/spinner.service";
import { InterceptorHttpService } from "./services/interceptor/interceptor-http.service";
import { BusquedaMenuComponent } from "./components/menu/busqueda-menu/busqueda-menu.component";
import { MenuService } from "./services/menu/menu.service";
import { InicioGuardService } from "./guards/inicio-guard/inicio-guard.service";
import { ClienteGuardService } from "./guards/cliente-guard/cliente-guard.service";
import { AgenteService } from "./services/agente/agente.service";
import { CardTipComponent } from "./components/shared/card-tip/card-tip.component";
import { MensajeSnackBarComponent } from "./components/shared/mensaje-snack-bar/mensaje-snack-bar.component";
import { MensajeSnackBarService } from "./services/mensaje-snack-bar/mensaje-snack-bar.service";
import { RegistroClienteComponent } from "./components/cliente/registro-cliente/registro-cliente.component";
import { DireccionClienteComponent } from "./components/cliente/registro-cliente/direccion-cliente/direccion-cliente.component";
import { ConsultaClienteDialogComponent } from "./components/cliente/dialogs/consulta-cliente-dialog/consulta-cliente-dialog.component";
import { RedireccionService } from "./services/redireccion/redireccion.service";
import { AdapterService } from "./services/adapter/adapter.service";
import { RegulacionService } from "./services/regulacion/regulacion.service";
// tslint:disable-next-line:max-line-length
import { AsesoriaYVentaClienteDialogComponent } from "./components/cliente/dialogs/asesoria-y-venta-cliente-dialog/asesoria-y-venta-cliente-dialog.component";
import { OnlyWordsDirective } from "./directives/only-words.directive";
import { ContenedorClienteComponent } from "./components/cliente/contenedor-cliente/contenedor-cliente.component";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { RefreshComponent } from "./components/shared/refresh/refresh.component";
import { AppDateApdater } from "./adapters/app-date-adapter/app-date-apdater.class";
import { APP_DATE_FORMATS } from "./contants/app-date-formats.constant";
// tslint:disable-next-line:max-line-length
import { MensajeInformativoDialogComponent } from "./components/shared/dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component";
import { UtilService } from "./services/util/util.service";
import { MasterMenuComponent } from "./components/menu/master-menu/master-menu.component";
import { WINDOW_PROVIDERS } from "./services/window/window.service";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_FORMATS,
} from "@angular/material-moment-adapter";
import { AlfaNumericDirective } from "./directives/alfa-numeric.directive";
import { ExternalSPComponent } from "./components/external-sp/external-sp.component";
import { FormioModule } from "angular-formio";
import { EncuestaComponent } from "./components/shared/encuesta/encuesta.component";
import { PreguntaEncuestaDialogComponent } from "./components/shared/encuesta/modal/pregunta-encuesta.component";
import { NavbarService } from "./services/navbar/navbar.service";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { CommonModule } from "@angular/common";
import { BuscarDialogComponent } from "./modules/mis-negocios/shared/components/buscar-dialog/buscar-dialog.component";
import { ValidarSarlafComponent } from "./modules/mis-negocios/shared/components/validar-sarlaf/validar-sarlaf.component";
import { ValidarDocumentoComponent } from "./modules/mis-negocios/shared/components/validar-documento/validar-documento.component";
import { MisNegociosComponent } from "./modules/mis-negocios/pages/mis-negocios.component";
import { MisNegociosSandbox } from "./modules/mis-negocios/mis-negocios.sandbox";
import { CotizacionesService } from "./modules/mis-negocios/shared/services/cotizaciones.service";
import { ForbiddenPageComponent } from "./components/shared/forbidden-page/forbidden-page.component";
import { ClienteDireccionService } from "./services/cliente-direccion/cliente-direccion.service";
import { BuscarClienteComponent } from './modules/mis-clientes/shared/components/buscar-cliente/buscar-cliente.component';
import { MisClientesComponent } from "./modules/mis-clientes/pages/mis-clientes.component";
import { MisClientesSandbox } from "./modules/mis-clientes/mis-clientes.sandbox";
import { ClientesService } from "./modules/mis-clientes/shared/services/clientes.service";

@NgModule({
  declarations: [
    AppComponent,
    SpinerComponent,
    FooterComponent,
    NavbarComponent,
    HomeComponent,
    ExamplePipe,
    MenuComponent,
    ContenedorComponent,
    SliderComponent,
    ConsultaClienteDialogComponent,
    LengthDirective,
    LengthNumberDirective,
    ValidarCiudadDirective,
    MensajeLabelNegocioComponent,
    BusquedaMenuComponent,
    CardTipComponent,
    MensajeSnackBarComponent,
    RegistroClienteComponent,
    ExternalSPComponent,
    DireccionClienteComponent,
    AsesoriaYVentaClienteDialogComponent,
    OnlyWordsDirective,
    ContenedorClienteComponent,
    RefreshComponent,
    MensajeInformativoDialogComponent,
    MasterMenuComponent,
    AlfaNumericDirective,
    EncuestaComponent,
    PreguntaEncuestaDialogComponent,
    MisNegociosComponent,
    BuscarDialogComponent,
    ValidarSarlafComponent,
    ValidarDocumentoComponent,
    ForbiddenPageComponent,
    MisClientesComponent,
    BuscarClienteComponent
  ],
  imports: [
    AngularFontAwesomeModule,
    Ng2AutoCompleteModule,
    NgbModule.forRoot(),
    CookieModule.forRoot({ httpOnly: true, domain: ".sura.com" }),
    BrowserModule,
    FormioModule,
    BlockUIModule,
    APP_ROUTING,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NoopAnimationsModule,
    MaterialModule,
    InfiniteScrollModule,
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 30000,
      positionClass: "toast-bottom-full-width",
      preventDuplicates: true,
      enableHtml: true,
    }),
  ],
  entryComponents: [
    SpinerComponent,
    MenuComponent,
    ConsultaClienteDialogComponent,
    MensajeSnackBarComponent,
    AsesoriaYVentaClienteDialogComponent,
    MensajeInformativoDialogComponent,
    PreguntaEncuestaDialogComponent,
    BuscarDialogComponent,
    ValidarSarlafComponent,
    ValidarDocumentoComponent,
    BuscarClienteComponent
  ],
  providers: [
    HttpCustom,
    InicioGuardService,
    ClienteGuardService,
    SpinnerService,
    HttpClientModule,
    { provide: MAT_DATE_LOCALE, useValue: "es-CO" },
    { provide: DateAdapter, useClass: AppDateApdater, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorHttpService,
      multi: true,
    },
    AgenteService,
    CookieService,
    DialogService,
    ClienteService,
    MenuService,
    MensajeSnackBarService,
    RedireccionService,
    AdapterService,
    RegulacionService,
    UtilService,
    NavbarService,
    MisNegociosSandbox,
    CotizacionesService,
    WINDOW_PROVIDERS,
    ClienteDireccionService,
    MisClientesSandbox,
    ClientesService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts